import React from 'react';
import Logo from '../../assets/images/logo@2x.png';
import './index.scss';
// import NotificationBar from '../common/NotificationBar';

export default function AuthHeader() {
  return (
    <div>
      {/* <NotificationBar /> */}
      <div className="auth-header">
        <a href="https://truelark.com/"><img src={Logo} alt="logo" width={150} /></a>
      </div>
    </div>
  );
}
